import { get } from '../../../../DAL/data-provider';

/**
 * /api/sitesearch/site-header-search?query=cla
 */
export const getSearchData = async (query: string) => {
    return get('/api/sitesearch/site-header-search', {
        query: query.trim(),
    });
};